// CUSTOM MODAL

import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import './CustomModalStyle.css';
import crossImg from '../../../Assets/CommonImages/crossImg.png'

function CustomModal({ open, handleClose, title, height, body, maxWidth, title_other }) {

    return (
        <div>
            <Dialog
                fullWidth={true}
                open={open}
                // onClose={() => { handleClose(false); }}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            height: height ? height : null,  // Set your width here
                            maxWidth: maxWidth ? maxWidth : "550px",  // Set your width here
                        },
                    },

                }}
            >
                <DialogTitle sx={{ background: '#567C09' }}>
                    {title ? (
                        <div className='custom_modal_multiple_header_text_container' >
                            <span className='custom_modal_multiple_header_text'>{title}</span>
                            <div className='employee-type-close-icon-container'>
                                <img onClick={() => handleClose(false)} src={crossImg} alt="close" className='close-icon' />
                                {/* {close} */}
                                {/* FOR CLOSE ICON OF MODAL */}
                            </div>
                        </div>
                    ) : <span className='custom_modal_multiple_header_text'>{title_other}</span>}
                </DialogTitle>
                <DialogContent>
                    {body}
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default CustomModal;
